import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CmsUiVideoContent } from '@lobos/library';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideosComponent {
  @Input() data!: CmsUiVideoContent;
  @Input() activeVideo = 0;

  public activate(index: number): void {
    this.activeVideo = index;
  }

  public next(): void {
    const total = this.data.videos.length;
    this.activeVideo = this.activeVideo + 1 >= total ? 0 : this.activeVideo + 1;
  }

  public prev(): void {
    const total = this.data.videos.length;
    this.activeVideo = this.activeVideo - 1 < 0 ? total - 1 : this.activeVideo - 1;
  }
}
